import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Charter de Iate Privado em Vilamoura · Morningstar · Algarve";
const DESC = "Charter de iate privado a partir de Vilamoura no Morningstar — um iate de 200 m² para até 18 pessoas, totalmente tripulado e com catering. Meio-dia, pôr-do-sol e dia completo no Algarve.";
const PATH = "/pt/charter-iate-privado-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.privateYachtVilamoura;

export const Route = createFileRoute("/pt/charter-iate-privado-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Charter de Iate Privado · Vilamoura · Algarve",
        title: "Charter de iate privado em Vilamoura no ",
        titleAccent: "Morningstar.",
        sub: "Um iate privado de 200 m² para até 18 pessoas, com partida da Marina de Vilamoura. Tripulado, com catering e inteiramente seu — charters de meio-dia, pôr-do-sol, Gruta de Benagil e dia completo no Algarve.",
        ctaPrimary: "Ver charters",
        ctaSecondary: "Pedir charter",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "charter iate vilamoura, aluguer iate vilamoura, iate privado algarve, charter iate algarve, luxo iate vilamoura",
      altPath: { en: "/private-yacht-charter-vilamoura", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Yacht Charter from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Charter de Iate Privado Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});
